import { Component, OnInit } from '@angular/core';
import { FacultyService } from 'src/app/service/faculty.service';
import { Router } from '@angular/router';
import { RestService } from 'src/app/service/rest.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  facultyId;
  FACULTY_NAME
  departments = []
  faculty_logo
  HAS_CREDIT
  branchId
  IS_REGISTRATION_OPEN = false
  constructor(private rest: FacultyService,
    private globalServ : RestService,
    private restApi: RestService,
    private router: Router) { }

  ngOnInit(): void {
    let data = this.globalServ.getFacultyIDAndName()
    this.facultyId = data.facultyId
    this.FACULTY_NAME = data.FACULTY_NAME
    this.branchId = data.branchId
    this.getData()
    this.getBranch()
    this.getDepart()

    // When a page resolves the real institute being viewed (e.g. an academy-wide
    // member profile on a non-institute host), re-sync the nav so it shows that
    // institute's name/logo/departments instead of the hostname default.
    this.globalServ.facultyContext.subscribe((ctx: any) => {
      if (!ctx || ctx.facultyId == this.facultyId) { return }
      this.facultyId = ctx.facultyId
      this.FACULTY_NAME = ctx.FACULTY_NAME
      this.branchId = ctx.branchId
      this.getData()
      this.getDepart()
    })
  }

  getBranch() {
    this.restApi.getbranch().subscribe((res: any) => {
      this.IS_REGISTRATION_OPEN = res.IS_REGISTRATION_OPEN
    })
  }

  getDepart() {
    this.rest.faculty_department(this.facultyId, this.branchId).subscribe((res: any) => {
      console.log("res ", res)
      this.departments = res.departments
    })
  }

  getData() {
    let data = this.globalServ.getFacultyIDAndName()
    let branch_id : any
    branch_id = data.branchId 
    this.rest.facultyHome(this.facultyId, branch_id).subscribe((res: any) => {
      console.log("res header", res)

      this.faculty_logo = res.FACULTY_LOGO
      this.HAS_CREDIT = res.HAS_CREDIT
    })
  }

  goto_depart(item) {
    this.router.navigate(['/department', item.ID]).then(() => {
      location.reload()
    })
  }

  faculty_fees(elemnt) {
    this.router.navigate(['/Education_system'])
    localStorage.setItem("elemnt", elemnt)
  }
}
